import { render, staticRenderFns } from "./AdminTenanciesView.vue?vue&type=template&id=580157f6&scoped=true"
import script from "./AdminTenanciesView.vue?vue&type=script&lang=js"
export * from "./AdminTenanciesView.vue?vue&type=script&lang=js"
import style0 from "./AdminTenanciesView.vue?vue&type=style&index=0&id=580157f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580157f6",
  null
  
)

export default component.exports